module.exports = __webpack_public_path__ + "media/assets/images/blog/testing-small-04b08c335a7e9d9ab0b19fc74d155be1.jpeg";